import { render, staticRenderFns } from "./UserTagModal.vue?vue&type=template&id=03d477b6"
import script from "./UserTagModal.vue?vue&type=script&lang=ts"
export * from "./UserTagModal.vue?vue&type=script&lang=ts"
import style0 from "./UserTagModal.vue?vue&type=style&index=0&id=03d477b6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports